import Vue from 'vue';
import { parse, startOfWeek, addDays, format } from 'date-fns';

export function isTrue(value: string | boolean) {
    return value === 'true' || value === true;
}

export function isFalse(value: string | boolean) {
    return value === 'false' || value === false;
}

export function generateRandomId(base = 'ID', length = 0) {
    if (length == 0) {
        length = !!base ? 6 : 4;
    }
    return base + Math.random().toString(36).substr(1, length + 1);
}

export function getLanguage(vm: Vue, fallbackLanguage?: string) {
    let language: string | undefined = undefined;

    if (vm && (<any>vm).$i18n) {
        language = (<any>vm).$i18n.language;
        fallbackLanguage = (<any>vm).$i18n.fallbackLanguage;
    }

    return { language, fallbackLanguage }
}

export function generateDaysNames(now: Date, dateFnsLocale?: any, formatPattern: string = 'cccccc') {
    let names = [];
    let d = startOfWeek(now);
    for (let i = 0 ; i < 7 ; i++) {
        names.push(format(d, formatPattern, { locale: dateFnsLocale }));
        d = addDays(d, 1);
    }
    return names;
}

export function round(value: number | null, d = '.', t = ',', precision = 2) {
    if (value == null) {
        return null;
    }
    let s = value < 0 ? '-' : '';
    let i = parseInt(Math.abs(parseFloat(value.toFixed(precision))) + '', 10) + '';
    let j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : '')
        + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t)
        + (precision ? d + Math.abs(value - parseInt(s + i, 10)).toFixed(precision).slice(precision) : '');
}

const reOnlyDigits = /[^\d]/g;

export function parseNumber(v: string, d = '') {
    if (v == null || v == '') {
        return null;
    }

    let separatorFound = false;

    // Find the rightmost separator and rebuild string around it. Note that this will
    // *not* work if the number contains thousand separators but not the decimal one
    // unless the decimalSeparator parameter has been specified.
    for (let i = v.length - 1 ; i >= 0 ; i--) {
        if (v[i] == d || (d == '' && (v[i] == '.' || v[i] == ','))) {
            separatorFound = true;
            v = v.substr(0, i).replace(reOnlyDigits, '') + '.' + v.substr(i + 1).replace(reOnlyDigits, '');
            break;
        }
    }

    // If a separator was not found, clean the string of everything except digits
    if (!separatorFound) {
        v = v.replace(reOnlyDigits, '');
    }

    return parseFloat(v);
}

export function parseDate(v: string, dateFnsLocale: any) {
    if (v == null || v == '') {
        return null;
    }

    return parse(v, "P", new Date(), { locale: dateFnsLocale });
}


function kebabize(key: string) {
    let s = "", n = false;

    for (let i = 0 ; i < key.length ; i++) {
        if (key[i].toLowerCase() != key[i] || (/\d/.test(key[i]) && !n)) {
            s += "-";
            s+= key[i].toLowerCase();
        }
        else {
            s += key[i];
        }

        n = /\d/.test(key[i]);
    }

    return s.replace(/(^-+|-+$)/g, '');
}

